import React from "react";
import {
  PitchTrackerFrame,
  PitchTrackerSvg,
} from "./EventPitchTrackerStyles";
import EventHalfPitchBaseLayer from "./EventHalfPitchBaseLayer";

const EventHalfPitchStaticPreview = ({
  fieldWidth,
  fieldHeight,
  fieldPadding = 0,
  grassStripeDirection = "horizontal",
}) => {
  return (
    <PitchTrackerFrame style={{ width: fieldWidth, margin: "0 auto" }}>
      <PitchTrackerSvg
        width={fieldWidth}
        height={fieldHeight}
        viewBox={`0 0 ${fieldWidth} ${fieldHeight}`}
        preserveAspectRatio="xMidYMid meet"
        $drawing={false}
        $grassStripeDirection={grassStripeDirection}
      >
        <EventHalfPitchBaseLayer
          fieldWidth={fieldWidth}
          fieldHeight={fieldHeight}
          fieldPadding={fieldPadding}
        />
      </PitchTrackerSvg>
    </PitchTrackerFrame>
  );
};

export default EventHalfPitchStaticPreview;
